"use client";

import { useState } from "react";
import {
  FaLinkedin,
  FaFacebook,
  FaInstagram,
  FaTiktok,
} from "react-icons/fa";
import Navbar from "../../components/Layout/Navbar";
import Footer from "../../components/Layout/Footer";
import { FaX } from "react-icons/fa6";
import api from "../../services/api";
import PageMeta from "../../components/pagesHelmet/PageMeta";

const BRAND = {
  primary: "#3B82F6",
  primaryDark: "#2563EB",
  primarySoft: "rgba(59, 130, 246, 0.1)",
  muted: "#6B7280",
  text: "#1F2937",
};

export default function ContactPage() {
  const [form, setForm] = useState({
    email: "",
    username: "",
    message: "",
    reference: "",
  });

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");


  const handleChange = (e) => {
  setForm({
    ...form,
    [e.target.name]: e.target.value,
  });
};

const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);
  setError("");
  setSuccess("");

  try {
    await api.post("/user/support", form);

    setSuccess("Your message has been sent successfully.");
    setForm({
      email: "",
      username: "",
      message: "",
      reference: "",
    });
  } catch (err) {
    setError(
      err.response?.data?.message || "Failed to send message. Try again."
    );
  } finally {
    setLoading(false);
  }
};

  return (
    <>
    <PageMeta 
      title="Contact Us | U2LR URL Shortener" 
      description="Get in touch with the U2LR team for support, inquiries, or feedback. We're here to help you with link management, QR codes, and analytics." 
    />
      <Navbar />
      <div className="bg-white">

        {/* ================= HERO ================= */}
        <section
          className="text-white"
          style={{
            background: `linear-gradient(135deg, #000, #4b76d1)`,
          }}
        >
          <div className="container py-5">
            <div className="row justify-content-center text-center">
              <div className="col-lg-8 py-5">
                <h1 className="display-6 fw-bold mb-3">Contact u2lr</h1>
                <p className="opacity-75 mb-0 fs-5">
                  Get in touch with u2lr support
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* ================= INTRO ================= */}
        <section className="py-5">
          <div className="container py-4">
            <div className="row justify-content-center">
              <div className="col-lg-9 text-center">
                <p className="fs-5 text-muted">
                  Need help with a shortened link, analytics, or your account?
                  Our team is here to help. Whether you’re troubleshooting an
                  issue or sharing feedback, we aim to respond quickly and
                  clearly.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* ================= CONTACT METHODS ================= */}
        <section className="py-5 bg-light">
          <div className="container py-4">
            <div className="row g-5">

              {/* EMAIL SUPPORT */}
              <div className="col-lg-4">
                <div className="h-100 bg-white rounded-4 shadow-sm p-4">
                  <h4 className="fw-bold mb-3">Email Support</h4>
                  <p className="text-muted mb-3">
                    For general support and account-related questions, email us at:
                  </p>
                  <a
                    href="mailto:support@u2lr.com"
                    className="fw-semibold text-decoration-none"
                    style={{ color: BRAND.primary }}
                  >
                    support@u2lr.com
                  </a>
                  {/* ================= SOCIAL FOLLOW ================= */}

{/* ================= SOCIAL FOLLOW ================= */}
<div className="mt-4 pt-3 border-top">
  <h6 className="fw-bold mb-2">Follow u2lr shortener</h6>
  <p className="text-muted small mb-3">
    Product updates, announcements, and support notices.
  </p>

  <div className="d-flex gap-3">
    <a
      href="x.com/u2lrlinks"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="u2lr on Twitter"
      className="text-decoration-none"
      style={{ color: BRAND.primary }}
    >
      <FaX size={22} />
    </a>

    <a
      href="www.linkedin.com/in/u2lrlink-shortener-008b943a7"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="u2lr on LinkedIn"
      className="text-decoration-none"
      style={{ color: BRAND.primary }}
    >
      <FaLinkedin size={22} />
    </a>

    <a
      href="https://www.facebook.com/profile.php?id=61587010800185"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="u2lr on Facebook"
      className="text-decoration-none"
      style={{ color: BRAND.primary }}
    >
      <FaFacebook size={22} />
    </a>

    <a
      href="https://www.instagram.com/u2lrlinks?igsh=eDZ2am1uc3ZzZm53&utm_source=qr"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="u2lr on Instagram"
      className="text-decoration-none"
      style={{ color: BRAND.primary }}
    >
      <FaInstagram size={22} />
    </a>
        <a
      href="https://www.tiktok.com/@u2lrshortener?is_from_webapp=1&sender_device=pc"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="u2lr on Tiktok"
      className="text-decoration-none"
      style={{ color: BRAND.primary }}
    >
      <FaTiktok size={22} />
    </a>
  </div>
</div>

                </div>
              </div>

              {/* SUPPORT FORM */}
              <div className="col-lg-8">
                <div className="bg-white rounded-4 shadow-sm p-4">
                  <h4 className="fw-bold mb-3">Support Form</h4>
                  <p className="text-muted mb-4">
                    Prefer to send a message directly from the site? Use the form
                    below and include as much detail as possible.
                  </p>

                  {success && (
                    <div className="alert alert-success">{success}</div>
                  )}

                  {error && (
                    <div className="alert alert-danger">{error}</div>
                  )}

                  <form onSubmit={handleSubmit}>
                    <div className="row g-3">

                      <div className="col-md-6">
                        <label className="form-label">Email address</label>
                          <input
                            type="email"
                            name="email"
                            className="form-control"
                            placeholder="you@example.com"
                            value={form.email}
                            onChange={handleChange}
                            required
                          />

                      </div>

                      <div className="col-md-6">
                        <label className="form-label">u2lr Username</label>
                          <input
                            type="text"
                            name="username"
                            className="form-control"
                            placeholder="your username"
                            value={form.username}
                            onChange={handleChange}
                          />

                      </div>

                      <div className="col-12">
                        <label className="form-label">Issue description</label>
                          <textarea
                            name="message"
                            className="form-control"
                            rows="5"
                            placeholder="Briefly describe the issue or question"
                            value={form.message}
                            onChange={handleChange}
                            required
                          />

                      </div>

                      <div className="col-12">
                        <label className="form-label">
                          Link or screenshot (optional)
                        </label>
                          <input
                            type="text"
                            name="reference"
                            className="form-control"
                            placeholder="Paste a link or reference"
                            value={form.reference}
                            onChange={handleChange}
                          />

                      </div>

                      <div className="col-12">
                        <button
                          type="submit"
                          className="btn btn-primary px-4 py-2"
                          style={{ backgroundColor: BRAND.primary }}
                          disabled={loading}
                        >
                          {loading ? "Sending..." : "Send message"}
                        </button>

                      </div>

                    </div>
                  </form>
                </div>
              </div>

            </div>
          </div>
        </section>

        {/* ================= RESPONSE TIME ================= */}
        <section className="py-5">
          <div className="container py-4 text-center">
            <h4 className="fw-bold mb-2">Response Time</h4>
            <p className="fs-5 text-muted mb-0">
              We aim to respond to all support requests within
            </p>
            <p
              className="fw-semibold fs-4 mt-2"
              style={{ color: BRAND.primary }}
            >
              10–60 minutes
            </p>
            <p className="text-muted mt-2">
              Response time may vary depending on request volume.
            </p>
          </div>
        </section>

      </div>

      <Footer />
    </>
  );
}
